import React, { useEffect } from "react";
import { msalInstance } from "../index";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  useIsAuthenticated,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

function Share() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated) {
      const account = msalInstance.getActiveAccount();
      if (!account) {
        msalInstance.loginPopup();
      } else {
        navigate(location.pathname.replace("/share", ""), {
          replace: true,
        });
      }
    } else {
      navigate(location.pathname.replace("/share", ""), {
        replace: true,
      });
    }
  }, []);

  return (
    <div>
      <UnauthenticatedTemplate>
        You must log in before viewing this record...
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        Login successful. Redirecting...
        <br />
        <br />
        If you're not redirected automatically, you can{" "}
        <Link to={location.pathname.replace("/share", "")}>click here</Link> to
        view the shared link.
      </AuthenticatedTemplate>
    </div>
  );
}

export default Share;
